import styled from 'styled-components';

export const StyledBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledMessage = styled.p`
  color: tomato;
`;
